import { AxiosInstance } from 'axios';
import { AUTH_ENDPOINTS } from './endpoints';

/** In-memory CSRF token — fetched once, reused for all mutating requests. */
let csrfToken: string | null = null;
let csrfPromise: Promise<string> | null = null;

export async function ensureCsrfToken(api: AxiosInstance): Promise<string> {
  if (csrfToken) {
    return csrfToken;
  }

  if (!csrfPromise) {
    csrfPromise = api
      .get<{ csrfToken: string }>(AUTH_ENDPOINTS.CSRF)
      .then((res) => {
        const token = res.data?.csrfToken;
        if (!token) {
          throw new Error('CSRF token missing from response');
        }
        csrfToken = token;
        return token;
      })
      .finally(() => {
        csrfPromise = null;
      });
  }

  return csrfPromise;
}

/** Clear cached token after CSRF failures so the next mutating call re-fetches. */
export function clearCsrfToken(): void {
  csrfToken = null;
  csrfPromise = null;
}
